import type { ItemSet } from '@exam-management/common/item-set-provider';
import type { QBankStructureLevelItemWithLevel } from '@exam-management/qbs-provider';

export function getLocationDefaultValue(
  questionStructures: ItemSet['questionStructures'],
  qBankStructureLevelItems: QBankStructureLevelItemWithLevel[],
) {
  const locations = qBankStructureLevelItems.filter((qBankStructureLevelItem) =>
    questionStructures?.some(
      (questionStructure) => questionStructure.refLevelItemId === qBankStructureLevelItem.id,
    ),
  );

  const levelItemLocation: Record<string, { label: string; value: string }> = {};

  for (const levelItem of locations) {
    const category = levelItem.qBankStructureLevel.category;
    levelItemLocation[category] = {
      label: levelItem.tag?.name ?? 'ไม่ระบุ',
      value: levelItem.id,
    };
  }

  return levelItemLocation;
}
